export const UPDATE_AS_READ_PROCESS_STATEMENT_FAILURE = 'UPDATE_AS_READ_PROCESS_STATEMENT_FAILURE';

export const updateAsReadProcessStatementFailure = error => ({
    type: UPDATE_AS_READ_PROCESS_STATEMENT_FAILURE,
    payload: error,
    error: true,
});
